import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, useTheme } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Subheading from "../../../../../../components/theme/text/Subheading";
import Text from "../../../../../../components/theme/text/Text";
import { tokens } from "../../../../../../theme";
import Echeck from "./views/Echeck";
import Invoicing from "./views/Invoicing";
import PickBasis from "./views/PickBasis";

import TabView3 from "../../../../../../components/theme/TabView3/TabView3";
import { useGetSettingsQuery } from "../../../../../../newapi/global/generalApiSlice";
import { getSettingsWarehouseGeneralCoreConfig } from "./settingsWarehouseGeneralCoreConfig";
import Inbound from "./views/Inbound";
import Relation from "./views/Relation";
import Replenish from "./views/Replenish";
import ReturnPortal from "./views/ReturnPortal";
import ServiceDesk from "./views/ServiceDesk";
import Integrations from "./views/Integrations";
import GeneralWarehouseSettings from "./views/General";
import ReturnsSettings from './views/ReturnsSettings';
import Orders from './views/Orders';
import Scorecard from './views/Scorecard';

const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: false,
    hide:true,
    

};

const Core = forwardRef((props, ref) => {
    const { t } = useTranslation();
    
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const config = getSettingsWarehouseGeneralCoreConfig(isFulfilment);

    const { data: incData} = useGetSettingsQuery("core");
    const [data, setData] = useState();
    
    useEffect(() => {
        setData(incData);
    },[incData]);

    useEffect(() => {
        props.replaceView({
            ...props.config,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    
    useImperativeHandle(ref, () => ({
    }));

    return (
        <Box
            sx={{
                padding:"0px 32px",
                paddingTop:"32px",
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            <Box
            sx={{
                //padding:"0px 32px",
                marginBottom:"32px",
                //height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                    display:'none'
                }}}
                >
                <Subheading>{t("core_settings_title")}</Subheading>
                <Text light>{t("core_settings_subtitle")}</Text>
            </Box>

            <TabView3
                 tabConfig={config}
                viewType="bodytabs"
                sx={{
                    position:"relative",
                    zIndex:2,
                    display: "flex",
                    flex:1,
                    minHeight:"calc(100% - 72px)",
                    // height:1,
                    "@media screen and (max-width: 47.9375em)" : {
                        "&:before" : {
                            content: "''",
                            display:"block",
                            position:"absolute",
                            left:0,
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            // transition:"250ms"
                        },
        
                        "&:after" : {
                            content: "''",
                            display:"block",
                            position:"absolute",
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            // transition:"250ms"
                        },
                    }
                  
                }}
                tabClasses={"btn-body-tab"}
            >
               <>
                    <PickBasis config={config.pickBasis}  />
                    <Inbound config={config.inbound} />
                    <Echeck config={config.echeck}/>
                    <Orders config={config.orders} />
                    {/* Ucomment this when 2.0.4 is out also do not forget the config*/}
                    <ReturnsSettings config={config.return} />
                    {isFulfilment && <Invoicing config={config.invoicing}/>}
                    {isFulfilment && <Relation config={config.relation}/>}
                    {isFulfilment && <ReturnPortal config={config.returnPortal}/>}
                    {/* {isFulfilment && <ServiceDesk config={config.serviceDesk}/>} */}
                    <Scorecard config={config.scorecard} />
                    <Integrations config={config.integrations} />

                    {/* //isFulfilment Only the case because we only have 1 general setting right now and it is dependent on isFulfilment */}
                    <GeneralWarehouseSettings config={config.general} />
                </>
            </TabView3>
        </Box>
    )
});

export default Core;